/**
 * Weather Legend Toggle Button
 * Shows in the layer control for ABB weather layers that have a legend
 */

import React from 'react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiPalette } from 'react-icons/pi';
import { LayerItem } from '@ais-ui/react-openlayers';
import { useWeatherLegend } from '../WeatherLegend';
import { cn } from '@ais-ui/utils';

interface WeatherLegendToggleProps {
  layer: LayerItem;
}

export const WeatherLegendToggle: React.FC<WeatherLegendToggleProps> = ({
  layer,
}) => {
  const { toggleLegend, isLegendActiveForLayer } = useWeatherLegend();

  const weatherLayerId =
    layer.properties?.abbLayerId || layer.id.replace('abb-weather-', '');

  const hasLegend = layer.properties?.hasLegend === true;
  const isActive = isLegendActiveForLayer(weatherLayerId);

  const handleClick = () => {
    toggleLegend(weatherLayerId, layer.name);
  };

  if (!hasLegend) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          id={`legend-toggle-${layer.id}`}
          size="icon"
          variant="ghost"
          className="h-9 w-9 flex-shrink-0 p-0 m-0"
          onClick={handleClick}
        >
          <PiPalette
            className={cn(
              'size-5',
              isActive ? 'text-primary' : 'text-muted-foreground/40',
            )}
          />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {isActive ? 'Hide legend' : 'Show legend'}
      </TooltipContent>
    </Tooltip>
  );
};

export default WeatherLegendToggle;
